export const urlSafeBase64 = (value: string | Buffer) => {
  return Buffer.from(value).toString('base64').replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};
